export enum CareerStatus {
  IN_PROGRESS = 'IN_PROGRESS',

  FINISHED = 'FINISHED',

  DROPPED = 'DROPPED',

  PENDING_SUBJECTS = 'PENDING_SUBJECTS',
}
